export default function Modal({ title, subtitle, onClose, children, testid, wide }) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-pine-deep/50 backdrop-blur-sm p-0 sm:p-4" onClick={onClose}>
      <div
        data-testid={testid}
        onClick={(e) => e.stopPropagation()}
        className={`w-full ${wide ? "max-w-2xl" : "max-w-md"} max-h-[92vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl bg-white shadow-grand p-5 sm:p-7 space-y-4`}
      >
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-display text-xl font-semibold text-pine-deep">{title}</h3>
            {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          <button type="button" onClick={onClose} aria-label="Close"
            className="rounded-full border border-pine/15 px-3 py-1.5 text-xs font-bold text-pine hover:bg-cream transition-colors">
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
